module.exports = __webpack_public_path__ + "static/media/leftArrowUnSelected.3eaf4151.svg";